import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Teleport as _Teleport, vModelRadio as _vModelRadio } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal mx-6 pt-6"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_5 = {
  class: "flex gap-2 flex-wrap border-t border-slate-200/60 pt-4"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "data-table-shell"
};
const _hoisted_8 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_9 = {
  class: "data-table text-sm min-w-[1200px]"
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  class: "data-table-td"
};
const _hoisted_12 = {
  class: "text-sm text-slate-900"
};
const _hoisted_13 = {
  class: "text-xs text-slate-500"
};
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  class: "data-table-td text-slate-900"
};
const _hoisted_17 = {
  class: "data-table-td"
};
const _hoisted_18 = {
  class: "text-sm text-slate-900"
};
const _hoisted_19 = {
  class: "text-xs text-slate-500"
};
const _hoisted_20 = {
  class: "data-table-td"
};
const _hoisted_21 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_22 = {
  class: "data-table-td is-right"
};
const _hoisted_23 = {
  key: 0,
  class: "money-text"
};
const _hoisted_24 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_25 = {
  class: "data-table-td is-right"
};
const _hoisted_26 = {
  key: 0,
  class: "money-text"
};
const _hoisted_27 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_28 = {
  class: "data-table-td is-right"
};
const _hoisted_29 = {
  key: 0,
  class: "money-text"
};
const _hoisted_30 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_31 = {
  class: "data-table-td"
};
const _hoisted_32 = {
  class: "data-table-td text-slate-600 text-xs"
};
const _hoisted_33 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_34 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["title", "aria-label", "onClick"];
const _hoisted_38 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_39 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_42 = {
  class: "text-sm text-slate-500"
};
const _hoisted_43 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6"
};
const _hoisted_44 = {
  key: 0,
  class: "mb-5 bg-slate-50 rounded-xl border border-slate-200 p-4"
};
const _hoisted_45 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_46 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_47 = {
  class: "font-mono text-xs text-slate-500 ml-1"
};
const _hoisted_48 = {
  class: "text-xs text-slate-500"
};
const _hoisted_49 = {
  class: "bg-white rounded-lg border border-slate-200 p-3"
};
const _hoisted_50 = {
  class: "text-xs text-slate-500 mb-1"
};
const _hoisted_51 = {
  class: "text-sm text-slate-900"
};
const _hoisted_52 = {
  key: 0,
  class: "money-text font-semibold"
};
const _hoisted_53 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_54 = {
  class: "text-xs text-slate-500 mt-1"
};
const _hoisted_55 = ["value"];
const _hoisted_56 = ["value"];
const _hoisted_57 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_58 = ["disabled"];
const _hoisted_59 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_60 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_61 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6"
};
const _hoisted_62 = {
  class: "flex items-center gap-2 mr-6 cursor-pointer"
};
const _hoisted_63 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_64 = {
  class: "flex items-center gap-2 mr-6 cursor-pointer"
};
const _hoisted_65 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_66 = {
  class: "relative w-full"
};
const _hoisted_67 = ["placeholder", "disabled"];
const _hoisted_68 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_69 = ["disabled"];
import { ref, reactive, computed, watch, nextTick, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import ExternalPersonSelector from '@/components/ExternalPersonSelector/index.vue';
import { getBankCardPage, createBankCard, updateBankCard, updateBankCardStatus, deleteBankCard, createFundTask } from '@/api/taxPlanning';
export default {
  __name: 'BankCardManagement',
  setup(__props) {
    const router = useRouter();
    const cardStatusMap = {
      1: {
        label: '启用',
        class: 'status-badge is-success'
      },
      0: {
        label: '停用',
        class: 'status-badge is-neutral'
      },
      default: {
        label: '未知',
        class: 'status-badge is-neutral'
      }
    };
    const accountTypeMap = {
      1: {
        label: '出账账户',
        class: 'is-indigo'
      },
      2: {
        label: '入账账户',
        class: 'is-teal'
      }
    };
    const accountTypeTabs = [{
      value: undefined,
      label: '全部'
    }, {
      value: 1,
      label: '出账账户'
    }, {
      value: 2,
      label: '入账账户'
    }];
    const filters = reactive({
      ownerType: undefined,
      ownerId: undefined,
      status: undefined,
      accountType: undefined,
      keyword: ''
    });
    const tableData = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const pagination = reactive({
      current: 1,
      size: 10,
      pages: 1
    });
    const formDialogVisible = ref(false);
    const submitting = ref(false);
    const formRef = ref(null);
    const formData = reactive({
      id: null,
      ownerType: 1,
      ownerId: null,
      accountType: 1,
      holderName: '',
      bankName: '',
      branchName: '',
      cardNo: '',
      dailyOutLimit: '',
      dailyInLimit: '',
      remark: ''
    });
    const isEdit = computed(() => !!formData.id);

    // 编辑回填的卡主显示名：卡主为已停用外部人员时不在下拉数据源中，选择器以此兜底显示，避免呈现“未知人员”
    const formOwnerFallbackName = ref('');

    // 编辑模式下卡号默认为脱敏值仅展示，点击编辑图标解锁后才允许重新输入完整卡号
    const cardNoEditable = ref(false);
    const cardNoInputRef = ref(null);

    // 切换账户类型时清空不再展示的限额字段，避免隐藏字段残留旧值
    watch(() => formData.accountType, type => {
      if (type === 1) {
        formData.dailyInLimit = '';
      } else {
        formData.dailyOutLimit = '';
      }
    });

    // 用户手动切换卡主类型时清空已选卡主，避免跨类型残留
    // （radio @change 仅用户操作触发；不用 watch 是为了避免编辑回填的程序性赋值被误清空）
    function handleFormOwnerTypeChange() {
      formData.ownerId = null;
      formOwnerFallbackName.value = '';
    }

    // 选中卡主后自动带出持卡人姓名（仍允许手工修改）
    function handleUserOwnerConfirm(users) {
      const name = users?.[0]?.name;
      if (name) formData.holderName = name;
    }
    function handlePersonOwnerChange(person) {
      if (person?.name) formData.holderName = person.name;
    }
    const taskDialogVisible = ref(false);
    const taskSubmitting = ref(false);
    const taskFormRef = ref(null);
    const taskForm = reactive({
      taskType: 1,
      totalAmount: '',
      remark: ''
    });
    const taskOwnerName = ref('');
    const taskCard = ref(null);
    const remainingQuota = (limit, used) => {
      if (limit === null || limit === undefined) return null;
      return Math.max(0, toNumber(limit) - toNumber(used));
    };

    // 新增资金任务弹窗只展示与卡账户类型匹配方向的限额（出账卡→转出，入账卡→转入，缺省按出账）
    const taskCardIsIn = computed(() => taskCard.value?.accountType === 2);
    const taskCardLimit = computed(() => taskCardIsIn.value ? taskCard.value?.dailyInLimit : taskCard.value?.dailyOutLimit);
    const taskCardUsed = computed(() => taskCardIsIn.value ? taskCard.value?.todayInUsed : taskCard.value?.todayOutUsed);
    const taskCardRemaining = computed(() => remainingQuota(taskCardLimit.value, taskCardUsed.value));
    const taskTypeFixedLabel = computed(() => taskForm.taskType === 2 ? '利润回填（入账账户）' : '税筹派发（出账账户）');

    // 列表"今日剩余限额"：按卡的账户类型取对应方向（出账卡看出账，入账卡看入账），缺省按出账处理
    const rowRemainingQuota = row => {
      if (row?.accountType === 2) return remainingQuota(row.dailyInLimit, row.todayInUsed);
      return remainingQuota(row?.dailyOutLimit, row?.todayOutUsed);
    };
    const taskUserLabel = computed(() => taskOwnerName.value || '-');
    const taskRules = {
      taskType: [{
        required: true,
        message: '请选择任务类型',
        trigger: 'change'
      }],
      totalAmount: [{
        required: true,
        message: '请输入总金额',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          const num = Number(value);
          if (!Number.isFinite(num) || num <= 0) {
            callback(new Error('总金额必须为大于0的数字'));
            return;
          }
          callback();
        },
        trigger: 'blur'
      }]
    };
    const validateLimit = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      const num = Number(value);
      if (!Number.isFinite(num) || num < 0) {
        callback(new Error('限额必须为非负数字，留空表示不限'));
        return;
      }
      callback();
    };
    const formRules = {
      ownerType: [{
        required: true,
        message: '请选择卡主类型',
        trigger: 'change'
      }],
      ownerId: [{
        required: true,
        message: '请选择卡主',
        trigger: 'change'
      }],
      accountType: [{
        required: true,
        message: '请选择账户类型',
        trigger: 'change'
      }],
      holderName: [{
        required: true,
        message: '请输入持卡人姓名',
        trigger: 'blur'
      }],
      bankName: [{
        required: true,
        message: '请输入开户银行名称',
        trigger: 'blur'
      }],
      cardNo: [{
        validator: (rule, value, callback) => {
          // 编辑模式未解锁卡号修改时跳过校验（脱敏值仅展示，不会提交）
          if (isEdit.value && !cardNoEditable.value) {
            callback();
            return;
          }
          if (!value) {
            callback(new Error('请输入银行卡号'));
            return;
          }
          if (!/^\d{8,30}$/.test(value)) {
            callback(new Error('银行卡号必须为8-30位数字'));
            return;
          }
          callback();
        },
        trigger: 'blur'
      }],
      dailyOutLimit: [{
        validator: validateLimit,
        trigger: 'blur'
      }],
      dailyInLimit: [{
        validator: validateLimit,
        trigger: 'blur'
      }]
    };
    function toNumber(value) {
      if (value === null || value === undefined || value === '') return 0;
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    }
    function formatAmount(value) {
      return toNumber(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    async function fetchCardList() {
      loading.value = true;
      try {
        const res = await getBankCardPage({
          page: pagination.current,
          size: pagination.size,
          ownerType: filters.ownerType,
          ownerId: filters.ownerId ? Number(filters.ownerId) : undefined,
          status: filters.status,
          accountType: filters.accountType,
          keyword: filters.keyword || undefined
        });
        tableData.value = res.records || [];
        total.value = res.total || 0;
        pagination.pages = Math.max(1, Math.ceil(total.value / pagination.size));
      } catch (error) {
        ElMessage.error('获取银行卡列表失败');
        console.error(error);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      fetchCardList();
    }
    function handleAccountTypeTabClick(value) {
      filters.accountType = value;
      handleSearch();
    }
    function handleReset() {
      filters.ownerType = undefined;
      filters.ownerId = undefined;
      filters.status = undefined;
      filters.accountType = undefined;
      filters.keyword = '';
      handleSearch();
    }

    // 切换卡主类型时清空已选卡主，避免跨类型残留
    function handleFilterOwnerTypeChange() {
      filters.ownerId = undefined;
    }

    // “全部类型”下选中系统用户卡主时自动对齐卡主类型（后端要求 ownerId 必须携带 ownerType；
    // 外部人员选择器仅在类型=外部人员时渲染，故此处的 ownerId 必为系统用户）
    watch(() => filters.ownerId, val => {
      if (val && filters.ownerType === undefined) {
        filters.ownerType = 1;
      }
    });
    function handlePageChange(page) {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      fetchCardList();
    }
    function handlePageSizeChange(size) {
      pagination.size = size;
      pagination.current = 1;
      fetchCardList();
    }
    function resetForm() {
      formData.id = null;
      formData.ownerType = 1;
      formData.ownerId = null;
      formOwnerFallbackName.value = '';
      formData.accountType = 1;
      formData.holderName = '';
      formData.bankName = '';
      formData.branchName = '';
      formData.cardNo = '';
      formData.dailyOutLimit = '';
      formData.dailyInLimit = '';
      formData.remark = '';
    }
    function handleCreate() {
      resetForm();
      cardNoEditable.value = true;
      formDialogVisible.value = true;
    }
    function handleEdit(row) {
      cardNoEditable.value = false;
      formData.id = row.id;
      formData.ownerType = row.ownerType ?? 1;
      formData.ownerId = row.ownerId;
      formOwnerFallbackName.value = row.ownerName || '';
      formData.accountType = row.accountType ?? 1;
      formData.holderName = row.holderName || '';
      formData.bankName = row.bankName || '';
      formData.branchName = row.branchName || '';
      formData.cardNo = row.cardNo || '';
      formData.dailyOutLimit = row.dailyOutLimit ?? '';
      formData.dailyInLimit = row.dailyInLimit ?? '';
      formData.remark = row.remark || '';
      formDialogVisible.value = true;
    }

    // 解锁卡号编辑：清空脱敏值，要求重新输入完整卡号
    function handleUnlockCardNo() {
      cardNoEditable.value = true;
      formData.cardNo = '';
      nextTick(() => {
        cardNoInputRef.value?.focus();
      });
    }
    function buildSubmitPayload() {
      const payload = {
        ownerType: Number(formData.ownerType),
        ownerId: Number(formData.ownerId),
        accountType: Number(formData.accountType),
        holderName: formData.holderName,
        bankName: formData.bankName,
        branchName: formData.branchName || undefined,
        remark: formData.remark || undefined
      };
      // 按账户类型只提交对应方向的限额；未传的字段后端会置为 null，顺带清掉旧方向的历史限额
      if (formData.accountType === 1) {
        payload.dailyOutLimit = formData.dailyOutLimit === '' ? undefined : Number(formData.dailyOutLimit);
      } else {
        payload.dailyInLimit = formData.dailyInLimit === '' ? undefined : Number(formData.dailyInLimit);
      }
      // 编辑模式未解锁卡号修改时不传 cardNo，后端保持原卡号不变
      if (!isEdit.value || cardNoEditable.value) {
        payload.cardNo = formData.cardNo;
      }
      return payload;
    }
    async function handleSubmit() {
      try {
        await formRef.value.validate();
      } catch {
        return;
      }
      submitting.value = true;
      try {
        const payload = buildSubmitPayload();
        if (isEdit.value) {
          await updateBankCard(formData.id, payload);
          ElMessage.success('更新成功');
        } else {
          await createBankCard(payload);
          ElMessage.success('新增成功');
        }
        formDialogVisible.value = false;
        fetchCardList();
      } catch (error) {
        ElMessage.error(error.message || '保存失败');
        console.error(error);
      } finally {
        submitting.value = false;
      }
    }
    function handleCreateTask(row) {
      // 出账卡只能创建税筹派发，入账卡只能创建利润回填，缺省按出账处理
      taskForm.taskType = row.accountType === 2 ? 2 : 1;
      taskForm.totalAmount = '';
      taskForm.remark = '';
      taskOwnerName.value = row.ownerName || row.holderName || '';
      taskCard.value = row;
      taskDialogVisible.value = true;
    }
    async function handleSubmitTask() {
      try {
        await taskFormRef.value.validate();
      } catch {
        return;
      }
      taskSubmitting.value = true;
      try {
        const taskId = await createFundTask({
          taskType: taskForm.taskType,
          cardId: Number(taskCard.value.id),
          totalAmount: Number(taskForm.totalAmount),
          remark: taskForm.remark || undefined
        });
        taskDialogVisible.value = false;
        try {
          await ElMessageBox.confirm('资金任务创建成功，是否前往任务详情处理？', '创建成功', {
            confirmButtonText: '前往处理',
            cancelButtonText: '留在本页',
            type: 'success'
          });
          if (taskId) {
            router.push(`/tax/fund-tasks/${taskId}`);
          }
        } catch {
          // 用户选择留在本页
        }
      } catch (error) {
        ElMessage.error(error.message || '创建失败');
        console.error(error);
      } finally {
        taskSubmitting.value = false;
      }
    }
    async function handleToggleStatus(row) {
      const nextStatus = row.status === 1 ? 0 : 1;
      const actionText = nextStatus === 1 ? '启用' : '停用';
      try {
        await ElMessageBox.confirm(`确认${actionText}银行卡「${row.holderName} ${row.cardNo}」吗？`, `${actionText}确认`, {
          confirmButtonText: `确认${actionText}`,
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      try {
        await updateBankCardStatus(row.id, nextStatus);
        ElMessage.success(`${actionText}成功`);
        fetchCardList();
      } catch (error) {
        ElMessage.error(error.message || `${actionText}失败`);
        console.error(error);
      }
    }
    async function handleDelete(row) {
      try {
        await ElMessageBox.confirm(`确认删除银行卡「${row.holderName} ${row.cardNo}」吗？删除后不可恢复。`, '删除确认', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
      } catch {
        return;
      }
      try {
        await deleteBankCard(row.id);
        ElMessage.success('删除成功');
        fetchCardList();
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
        console.error(error);
      }
    }
    onMounted(() => {
      fetchCardList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "银行卡管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "维护税筹派发与利润回填使用的银行卡，管理出账/入账日限额与启停用状态。")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn-primary inline-flex items-center gap-2",
          onClick: handleCreate
        }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
        })], -1), _createTextVNode(" 新增银行卡 ", -1)]))])), [[_directive_permission, 'tax-planning:card:add']])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchCardList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          extra: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(accountTypeTabs, tab => {
            return _createElementVNode("button", {
              key: String(tab.value),
              type: "button",
              class: _normalizeClass(['px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200', filters.accountType === tab.value ? 'bg-primary-100 text-primary-700 shadow-sm' : 'bg-slate-100 text-slate-600 hover:bg-slate-200']),
              onClick: $event => handleAccountTypeTabClick(tab.value)
            }, _toDisplayString(tab.label), 11, _hoisted_6);
          }), 64))])]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filters.ownerType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.ownerType = $event),
            placeholder: "卡主类型",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterOwnerTypeChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: undefined
            }), _createVNode(_component_el_option, {
              label: "系统用户",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "外部人员",
              value: 2
            })]),
            _: 1
          }, 8, ["modelValue"]), filters.ownerType !== 2 ? (_openBlock(), _createBlock(UserSelector, {
            key: 0,
            modelValue: filters.ownerId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.ownerId = $event),
            placeholder: "选择卡主（系统用户）",
            class: "form-control-sm filter-bar-field"
          }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(ExternalPersonSelector, {
            key: 1,
            modelValue: filters.ownerId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.ownerId = $event),
            placeholder: "选择卡主（外部人员）",
            class: "form-control-sm filter-bar-field"
          }, null, 8, ["modelValue"])), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: undefined
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filters.keyword = $event),
            type: "text",
            placeholder: "持卡人/卡号",
            class: "form-search-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, filters.keyword]])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_cache[35] || (_cache[35] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "卡主"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "账户类型"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "持卡人"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "银行/支行"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "卡号"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "出账日限额"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "入账日限额"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "今日剩余限额"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, m => {
            return _createElementVNode("td", {
              key: m,
              class: _normalizeClass(["data-table-td", m === 11 ? 'data-table-sticky-right data-table-sticky-action' : ''])
            }, [...(_cache[28] || (_cache[28] = [_createElementVNode("div", {
              class: "h-4 bg-slate-200 rounded w-24"
            }, null, -1)]))], 2);
          }), 64))]);
        }), 64)) : tableData.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[29] || (_cache[29] = [_createElementVNode("td", {
          colspan: "11",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
        })]), _createElementVNode("span", {
          class: "text-slate-500"
        }, "暂无银行卡")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString(row.ownerName || '-') + " ", 1), _createElementVNode("span", {
            class: _normalizeClass(["status-badge ml-1", row.ownerType === 2 ? 'is-teal' : 'is-indigo'])
          }, _toDisplayString(row.ownerType === 2 ? '外部人员' : '系统用户'), 3)]), _createElementVNode("div", _hoisted_13, "ID: " + _toDisplayString(row.ownerId || '-'), 1)]), _createElementVNode("td", _hoisted_14, [accountTypeMap[row.accountType] ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["status-badge", accountTypeMap[row.accountType].class])
          }, _toDisplayString(accountTypeMap[row.accountType].label), 3)) : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))]), _createElementVNode("td", _hoisted_16, _toDisplayString(row.holderName || '-'), 1), _createElementVNode("td", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(row.bankName || '-'), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(row.branchName || '-'), 1)]), _createElementVNode("td", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(row.cardNo || '-'), 1)]), _createElementVNode("td", _hoisted_22, [row.dailyOutLimit !== null && row.dailyOutLimit !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_23, "¥" + _toDisplayString(formatAmount(row.dailyOutLimit)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_24, "--"))]), _createElementVNode("td", _hoisted_25, [row.dailyInLimit !== null && row.dailyInLimit !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_26, "¥" + _toDisplayString(formatAmount(row.dailyInLimit)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_27, "--"))]), _createElementVNode("td", _hoisted_28, [rowRemainingQuota(row) !== null ? (_openBlock(), _createElementBlock("span", _hoisted_29, "¥" + _toDisplayString(formatAmount(rowRemainingQuota(row))), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_30, "--"))]), _createElementVNode("td", _hoisted_31, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", cardStatusMap[row.status]?.class || cardStatusMap.default.class])
          }, _toDisplayString(cardStatusMap[row.status]?.label || '未知'), 3)]), _createElementVNode("td", _hoisted_32, _toDisplayString(row.createTime || '-'), 1), _createElementVNode("td", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-teal",
            title: "新增资金任务",
            "aria-label": "新增资金任务",
            onClick: $event => handleCreateTask(row)
          }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)]))], 8, _hoisted_35)), [[_directive_permission, 'tax-planning:task:create']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑",
            onClick: $event => handleEdit(row)
          }, [...(_cache[31] || (_cache[31] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_36)), [[_directive_permission, 'tax-planning:card:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: _normalizeClass(["table-action-button", row.status === 1 ? 'is-warning' : 'is-success']),
            title: row.status === 1 ? '停用' : '启用',
            "aria-label": row.status === 1 ? '停用' : '启用',
            onClick: $event => handleToggleStatus(row)
          }, [row.status === 1 ? (_openBlock(), _createElementBlock("svg", _hoisted_38, [...(_cache[32] || (_cache[32] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
          }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_39, [...(_cache[33] || (_cache[33] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          }, null, -1)]))]))], 10, _hoisted_37)), [[_directive_permission, 'tax-planning:card:status']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => handleDelete(row)
          }, [...(_cache[34] || (_cache[34] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_40)), [[_directive_permission, 'tax-planning:card:remove']])])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination,
          total: total.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "total"])]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: taskDialogVisible.value,
          size: "lg",
          onClose: _cache[9] || (_cache[9] = $event => taskDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", null, [_cache[36] || (_cache[36] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "新增资金任务", -1)), _createElementVNode("p", _hoisted_42, " 为「" + _toDisplayString(taskUserLabel.value) + "」创建税筹派发或利润回填任务，创建后可前往任务详情逐笔生成操作记录。 ", 1)]), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[5] || (_cache[5] = $event => taskDialogVisible.value = false)
          }, [...(_cache[37] || (_cache[37] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_43, [taskCard.value ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createTextVNode(_toDisplayString(taskCard.value.holderName) + " ", 1), _createElementVNode("span", _hoisted_47, _toDisplayString(taskCard.value.cardNo), 1)]), _createElementVNode("div", _hoisted_48, _toDisplayString(taskCard.value.bankName) + _toDisplayString(taskCard.value.branchName ? ' · ' + taskCard.value.branchName : ''), 1)]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, _toDisplayString(taskCardIsIn.value ? '转入（入账）' : '转出（出账）'), 1), _createElementVNode("div", _hoisted_51, [_cache[38] || (_cache[38] = _createTextVNode(" 剩余限额： ", -1)), taskCardRemaining.value !== null ? (_openBlock(), _createElementBlock("span", _hoisted_52, "¥" + _toDisplayString(formatAmount(taskCardRemaining.value)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_53, "--"))]), _createElementVNode("div", _hoisted_54, " 日限额 " + _toDisplayString(taskCardLimit.value !== null && taskCardLimit.value !== undefined ? '¥' + formatAmount(taskCardLimit.value) : '--') + " · 当日已用 ¥" + _toDisplayString(formatAmount(taskCardUsed.value)), 1)])])) : _createCommentVNode("", true), _createVNode(_component_el_form, {
            ref_key: "taskFormRef",
            ref: taskFormRef,
            model: taskForm,
            rules: taskRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "卡主"
            }, {
              default: _withCtx(() => [_createElementVNode("input", {
                value: taskUserLabel.value,
                type: "text",
                disabled: "",
                class: "form-input w-full bg-slate-50 text-slate-500"
              }, null, 8, _hoisted_55)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "任务类型",
              prop: "taskType"
            }, {
              default: _withCtx(() => [_createElementVNode("input", {
                value: taskTypeFixedLabel.value,
                type: "text",
                disabled: "",
                class: "form-input w-full bg-slate-50 text-slate-500"
              }, null, 8, _hoisted_56)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "总金额",
              prop: "totalAmount"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => taskForm.totalAmount = $event),
                type: "text",
                placeholder: "请输入总金额（元）",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, taskForm.totalAmount]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => taskForm.remark = $event),
                rows: "3",
                placeholder: "可选填写备注信息",
                class: "form-textarea w-full resize-none"
              }, null, 512), [[_vModelText, taskForm.remark]])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[8] || (_cache[8] = $event => taskDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: taskSubmitting.value,
            onClick: handleSubmitTask
          }, _toDisplayString(taskSubmitting.value ? '提交中...' : '提交'), 9, _hoisted_58)])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: formDialogVisible.value,
          size: "lg",
          onClose: _cache[25] || (_cache[25] = $event => formDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createElementVNode("h3", _hoisted_60, _toDisplayString(isEdit.value ? '编辑银行卡' : '新增银行卡'), 1), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[10] || (_cache[10] = $event => formDialogVisible.value = false)
          }, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_61, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: formData,
            rules: formRules,
            "label-width": "110px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "卡主类型",
              prop: "ownerType"
            }, {
              default: _withCtx(() => [_createElementVNode("label", _hoisted_62, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.ownerType = $event),
                type: "radio",
                class: "form-radio",
                value: 1,
                onChange: handleFormOwnerTypeChange
              }, null, 544), [[_vModelRadio, formData.ownerType]]), _cache[40] || (_cache[40] = _createElementVNode("span", {
                class: "text-sm text-slate-700"
              }, "系统用户", -1))]), _createElementVNode("label", _hoisted_63, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.ownerType = $event),
                type: "radio",
                class: "form-radio",
                value: 2,
                onChange: handleFormOwnerTypeChange
              }, null, 544), [[_vModelRadio, formData.ownerType]]), _cache[41] || (_cache[41] = _createElementVNode("span", {
                class: "text-sm text-slate-700"
              }, "外部人员", -1))])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "卡主",
              prop: "ownerId"
            }, {
              default: _withCtx(() => [formData.ownerType === 1 ? (_openBlock(), _createBlock(UserSelector, {
                key: 0,
                modelValue: formData.ownerId,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.ownerId = $event),
                placeholder: "请选择系统用户",
                class: "w-full",
                onConfirm: handleUserOwnerConfirm
              }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(ExternalPersonSelector, {
                key: 1,
                modelValue: formData.ownerId,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formData.ownerId = $event),
                placeholder: "请选择外部人员",
                class: "w-full",
                "fallback-name": formOwnerFallbackName.value,
                onChange: handlePersonOwnerChange
              }, null, 8, ["modelValue", "fallback-name"]))]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "账户类型",
              prop: "accountType"
            }, {
              default: _withCtx(() => [_createElementVNode("label", _hoisted_64, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formData.accountType = $event),
                type: "radio",
                class: "form-radio",
                value: 1
              }, null, 512), [[_vModelRadio, formData.accountType]]), _cache[42] || (_cache[42] = _createElementVNode("span", {
                class: "text-sm text-slate-700"
              }, "出账账户", -1))]), _createElementVNode("label", _hoisted_65, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => formData.accountType = $event),
                type: "radio",
                class: "form-radio",
                value: 2
              }, null, 512), [[_vModelRadio, formData.accountType]]), _cache[43] || (_cache[43] = _createElementVNode("span", {
                class: "text-sm text-slate-700"
              }, "入账账户", -1))])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "持卡人",
              prop: "holderName"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => formData.holderName = $event),
                type: "text",
                placeholder: "请输入持卡人姓名",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.holderName]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "开户银行",
              prop: "bankName"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => formData.bankName = $event),
                type: "text",
                placeholder: "请输入开户银行名称",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.bankName]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "支行名称"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => formData.branchName = $event),
                type: "text",
                placeholder: "请输入支行名称（选填）",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.branchName]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "银行卡号",
              prop: "cardNo"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_withDirectives(_createElementVNode("input", {
                ref_key: "cardNoInputRef",
                ref: cardNoInputRef,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => formData.cardNo = $event),
                type: "text",
                placeholder: isEdit.value && cardNoEditable.value ? '请输入新的银行卡号' : '请输入银行卡号',
                disabled: isEdit.value && !cardNoEditable.value,
                class: _normalizeClass(["form-input w-full font-mono", {
                  'bg-slate-50 text-slate-500': isEdit.value && !cardNoEditable.value,
                  'pr-8': isEdit.value && !cardNoEditable.value
                }])
              }, null, 10, _hoisted_67), [[_vModelText, formData.cardNo]]), isEdit.value && !cardNoEditable.value ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "absolute right-2 top-1/2 -translate-y-1/2 p-1 text-slate-400 hover:text-slate-600",
                title: "修改卡号",
                "aria-label": "修改卡号",
                onClick: handleUnlockCardNo
              }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              })], -1)]))])) : _createCommentVNode("", true)])]),
              _: 1
            }), formData.accountType === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "出账日限额",
              prop: "dailyOutLimit"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => formData.dailyOutLimit = $event),
                type: "text",
                placeholder: "留空表示不限",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.dailyOutLimit]])]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "入账日限额",
              prop: "dailyInLimit"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => formData.dailyInLimit = $event),
                type: "text",
                placeholder: "留空表示不限",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, formData.dailyInLimit]])]),
              _: 1
            })), _createVNode(_component_el_form_item, {
              label: "备注"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => formData.remark = $event),
                rows: "3",
                placeholder: "可选填写备注信息",
                class: "form-textarea w-full resize-none"
              }, null, 512), [[_vModelText, formData.remark]])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_68, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[24] || (_cache[24] = $event => formDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: submitting.value,
            onClick: handleSubmit
          }, _toDisplayString(submitting.value ? '保存中...' : '保存'), 9, _hoisted_69)])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};